import React, {Component} from 'react';
import {Trans} from '@lingui/macro';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';
import debounce from 'lodash.debounce';

import {login} from '../../actions/login';
import {loadLanguages} from '../../actions/languages';
import {isLoginPending} from '../../reducers/login';

import SkillupLogo from '../../components/Icons/SkillupLogo';
import Button from '../../components/Button';

import {RESET} from '../../services/routes';
import {I18nRenderProp} from '../../services/i18n';
import {getSuffix} from '@services/utilities';

import cl from 'classnames';
import s from './Login.css';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: props.history?.location?.state?.username || '',
      password: '',
    };
  }

  componentDidMount() {
    this.props.loadLanguages();
  }

  debouncedLogin = debounce(this.props.login, 200);

  onUsernameChange = event => this.setState({username: event.target.value});
  onPasswordChange = event => this.setState({password: event.target.value});

  onSubmit = event => {
    const {username, password} = this.state;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.debouncedLogin(username, password, timezone);
    event.preventDefault();
  };

  goToResetPage = e => {
    this.props.push(RESET);
    e.stopPropagation();
    e.preventDefault();
  };

  render() {
    const {isPending} = this.props;
    const {username, password} = this.state;
    const isActive =
      typeof username !== 'undefined' &&
      username.length > 0 &&
      typeof password !== 'undefined' &&
      password.length > 0;

    return (
      <div className={cl(s.LoginPage)}>
        <SkillupLogo className={s.Logo} negative size="38px" />

        <p className={s.Welcome}>
          <Trans id="login.placeholder_welcome">Benvenuto.</Trans>
        </p>

        <section className={s.LoginForm}>
          <form onSubmit={this.onSubmit}>
            <I18nRenderProp>
              {({i18n}) => (
                <section>
                  <input
                    type="text"
                    className={s.TextField}
                    placeholder={i18n._({
                      id: 'login.placeholder_email',
                      message: 'Indirizzo email aziendale',
                    })}
                    value={username}
                    onChange={this.onUsernameChange}
                  />
                  <input
                    type="password"
                    className={s.TextField}
                    placeholder={i18n._({
                      id: 'login.placeholder_password',
                      message: 'Password',
                    })}
                    value={password}
                    onChange={this.onPasswordChange}
                  />
                </section>
              )}
            </I18nRenderProp>
            <section className={s.ButtonContainer}>
              <Button className={cl(s.SendButton, isActive && s.Active)} loading={isPending}>
                <span>
                  <Trans id="login.label_login">Accedi</Trans>
                </span>
              </Button>
            </section>
          </form>
        </section>

        <p className={s.PasswordReset}>
          <a href="#" onClick={this.goToResetPage}>
            <Trans id="login.forget_password">Hai dimenticato la password?</Trans>
          </a>
        </p>

        <p className={s.Copyright}>{`Skillup © ${new Date().getFullYear()} ${getSuffix()}`}</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isPending: isLoginPending(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({login, push, loadLanguages}, dispatch);
}

export const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
